import { createRoutine } from "../utils/routine.utils";
import { createAction } from "redux-act";
export var getComments = createRoutine("COMMENTS_GET");
export var createComment = createRoutine("COMMENT_CREATE");
export var updateComment = createRoutine("COMMENT_UPDATE");
export var deleteComment = createRoutine("COMMENT_DELETE");
export var setShowLimit = createAction("COMMENT_SET_SHOW_LIMIT");
